import Constants from 'expo-constants';
import { useEffect } from 'react';
import React from 'react';
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { SystemBars } from 'react-native-edge-to-edge';

import { i18n } from '@/utils/i18n';

import Text from '../Text';

interface MaintenanceOverlayProps {
  overlayStyle?: StyleProp<ViewStyle>;
  visible: boolean;
}

const MaintenanceOverlay = ({ overlayStyle, visible }: MaintenanceOverlayProps): React.JSX.Element | null => {
  const statusBarHeight = Constants.statusBarHeight;

  useEffect(() => {
    if (!visible) return;

    const entry = SystemBars.pushStackEntry({
      style: {
        statusBar: 'light',
        navigationBar: 'auto'
      }
    });

    return () => {
      SystemBars.popStackEntry(entry);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <View style={styles.absoluteFill} pointerEvents="auto">
      <View style={styles.overlayBackground} />
      <View
        style={[
          styles.bannerView,
          overlayStyle,
          {
            paddingTop: Platform.OS === 'web' ? 18 : Platform.OS === 'android' ? statusBarHeight + 18 : statusBarHeight
          }
        ]}>
        <Text fontWeight="900" style={styles.titleText}>
          {i18n.t('maintenance_modal.title')}
        </Text>
        <Text style={styles.descriptionText}>{i18n.t('maintenance_modal.description')}</Text>
      </View>
    </View>
  );
};

export default MaintenanceOverlay;

const styles = StyleSheet.create({
  absoluteFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    justifyContent: 'flex-start',
    alignItems: 'center'
  },

  overlayBackground: {
    ...StyleSheet.absoluteFill,
    backgroundColor: '#000000b3'
  },

  bannerView: {
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#973131',
    paddingBottom: 20
  },

  titleText: {
    fontSize: 18,
    textAlign: 'center',
    color: 'white'
  },

  descriptionText: {
    fontSize: 16,
    textAlign: 'center',
    color: 'white'
  }
});
